<template>
  <div class="w-full h-full yuandan-bg-color">
    <div class="yuandan">
      <div class="absolute top-0 left-0 w-full h-full flex overflow-hidden">
        <Snow class="w-full h-full" />
      </div>
      <img
        src="./assets/cloud_left_1.png"
        class="show-pc absolute bottom-0 left-0 w-60 select-none"
      />
      <img
        src="./assets/panda_1.png"
        class="show-pc absolute bottom-0 left-0 w-28 select-none"
      />
      <img
        src="./assets/firework_left_1.png"
        class="show-pc absolute firework-left w-20 select-none"
      />
      <img
        src="./assets/cloud_right_1.png"
        class="show-pc absolute bottom-0 right-0 w-60 select-none"
      />
      <img
        src="./assets/tree_right_1.png"
        class="show-pc absolute -top-6 right-0 w-40 select-none"
      />
      <img
        src="./assets/lantern_right_1.png"
        class="show-pc absolute -top-2 right-0 w-20 select-none"
      />
      <img
        src="./assets/cloud_left_1.png"
        class="show-mb absolute bottom-0 left-0 w-36 select-none"
      />
      <img
        src="./assets/cloud_right_1.png"
        class="show-mb absolute bottom-0 right-0 w-36 select-none"
      />
      <img
        src="./assets/tree_right_2.png"
        class="show-mb absolute -top-10 right-0 w-28 select-none"
      />
    </div>
    <div class="show-pc h-full">
      <LoadingControl v-if="loading" styleType="yuandan-bsload" class="w-full" />
      <div v-else class="h-full w-full relative">
        <div class="flex items-center justify-center h-full">
          <EnterIcon class="w-12" :disabled="disabledEnter" disabledColor="#FFA391" color="#fff" />
          <span v-if="portalView" class="font-bold text-sm yuandan-enter">Back</span>
          <span
            v-else
            :class="[
              'font-bold text-sm yuandan-enter select-none',
              disabledEnter ? 'disabled' : ''
            ]"
            >继续</span
          >
        </div>
      </div>
    </div>
    <div class="show-mb flex items-center justify-between h-full w-full relative">
      <div class="flex-1" @click.stop="$emit('menu')" @touchstart.stop>
        <MenuIcom class="mx-auto" activeColor="#FFF095" color="#fff" />
      </div>
      <div class="flex-2 h-full rounded-md flex items-center">
        <LoadingControl v-if="loading" class="mx-auto" styleType="yuandan-bsload" />
        <EnterIcon
          v-else
          class="w-12 bg-transparent mx-auto"
          color="#fff"
          disabledColor="#FFA391"
          :disabled="disabledEnter"
        />
      </div>
      <div class="flex-1 w-full" @click.stop="$emit('setting')">
        <v-popover class="w-full" trigger="click" :open.sync="popoverVisible">
          <SettingIcon
            class="mx-auto"
            :visible="popoverVisible"
            activeColor="#FFF095"
            color="#fff"
          />
          <template #popover>
            <div
              class="w-20 text-center active:bg-gray-400 enter text-lg font-medium"
              @click="$emit('relearn')"
            >
              重新学习
            </div>
          </template>
        </v-popover>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import MenuIcom from '../assets/MenuIcon.vue';
import SettingIcon from '../assets/SettingIcon.vue';
import LoadingControl from '../assets/LoadingControl.vue';
import EnterIcon from '../assets/EnterIcon.vue';
import Snow from './snowBg.vue'
@Component({
  components: {
    MenuIcom,
    SettingIcon,
    LoadingControl,
    EnterIcon,
    Snow
  }
})
export default class YuanDan extends Vue {
  @Prop({ type: Boolean }) loading: boolean;
  @Prop({ type: String }) customText: string;
  @Prop({ type: Boolean }) disabledEnter: boolean;
  @Prop({ type: Boolean }) popoverVisible: boolean;

  get portalView() {
    const portalSequence = this.$store.state.common.portalSequence;
    return portalSequence[portalSequence.length - 1];
  }
  transitPopoverVisible = false;
  mounted() {
    this.transitPopoverVisible = this.popoverVisible;
  }

  @Watch('_popoverVisible')
  popoverVisibleChange() {
    this.$emit('update:popoverVisible', this.transitPopoverVisible);
  }
}
</script>
<style scoped>
.show-pc {
  @apply hidden md:flex;
}
.show-mb {
  @apply flex md:hidden;
}
.enter {
  color: #6c48e9;
}
.flex-2 {
  flex: 2;
}
.disabled {
  color: #FFA391 !important;
}
.yuandan-bg-color {
  background: #FF6647;

}
.yuandan-enter {
  color: #fff;
}

.firework-left {
  top: -70px;
  left: 60px;
}
</style>
